<div
  class="bg-white p-5 w-100 max-450 border-radius-10 m-auto mrb-10 mrb-md-0 box-shadow height-600px"
>
  <div class="">
    <img
      class="w-100 max-430 height-450px border-radius-10"
      [src]="image"
      alt="card img"
      defaultImage
    />
  </div>
  <div class="pse-5">
    <div class="text-center size-9 weight-700 ptb-10 max-height-100 pse-5">
      {{ title }}
    </div>
    <div class="card-text"></div>
    <div class="mrb-5 end-hover-btn">
      <a
        class="more-btn hover-more-btn d-flex justify-content-end align-items-center mrt-10"
        href="#"
      >
        <div class="size-3 weight-700 mre-5">{{ "knowMore" | translate }}</div>
        <svg-icon
          class="arrow"
          src="../../../../assets/images/arrow.svg"
        ></svg-icon>
      </a>
    </div>
  </div>
</div>
